import SectionButtonGroup from "../../../../../components/Button/SectionButtonGroup";
import InfoCancerText from "./InfoCancerText";
import StatisticsCancerText from "./StatisticsCancerText";


export default function MicroButtonGroup() {

return(
<>      

<SectionButtonGroup

      button_1 = "IMPORTANT READ"
      button_2 = "SEQUENCING INFO"
      button_3 = "COUNSELING"
      
      title_dialog_1 = "Important Read"
      content_dialog_1 = {<InfoCancerText />}
      
      title_dialog_2 = "Sequencing Information"
      content_dialog_2 = {<StatisticsCancerText />}

      to = "/Doctor"

/>

</>
)}